// Welcome.js

import React from "react";
import { translations } from "../translations";

const Welcome = ({ selectLanguage = "fr" }) => {
  const lang = translations[selectLanguage];

  
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <img
        src="https://ui-chatbot1.s3.eu-north-1.amazonaws.com/rentabook.png"
        alt="Welcome"
        className="w-39 h-24 mb-5" //w-26.25 h-16 mb-5f
      />
      <div className="text-center">
        <h1
          style={{
            fontWeight: "bold",
          }}
          className="text-xl font-semibold mb-2"
        >
          {lang.welcome}
        </h1>
        <p className="text-l">{lang.askQuestions}</p>
        <p className="text-m">{lang.discover}</p>
      </div>
    </div>
  );
};

export default Welcome;
